export function decipherError (err) {
  if (!err) return 'An unexpected error occurred'

  // RFC 7807 Problem Details lives at either `.response` or `.response.data`
  // depending on which client layer surfaces the error.
  const pd = err.response?.type ? err.response : (err.response?.data?.type ? err.response.data : null)
  if (pd) {
    return pd.detail || pd.title || pd.message || err.toString()
  }

  return err.toString()
}
